import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import React from 'react';

import Images from '../../constants/images';

const Welcome = ({isLoading}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          size="30rem"
          thickness={0.2}
          sx={{
            position: 'absolute',
            zIndex: 1,
          }}
        />
        <img src={Images.hubLogo} alt="hublogo" />
        <Typography variant="h5" component="h5">
          PHOENIX
        </Typography>
        <Typography variant="body1">{isLoading ? 'Loading ...' : ''}</Typography>
      </Box>
    </Box>
  );
};

export default Welcome;
